import './Effect.css';
import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { wait } from '../../util/util';

interface Props {
  children: React.ReactNode | null;
  animationDuration?: number;
  effect?: EffectName;
  animateOnEnter?: boolean;
}

type EffectState = 'entering' | 'leaving' | 'gone' | 'present';
type EffectName = 'pop' | 'fade';

export function Effect({ children, animationDuration = 0.25, effect = 'fade', animateOnEnter }: Props): JSX.Element {
  const contentRef = useRef<React.ReactNode>(null);
  const [state, setState] = useState<EffectState>(animateOnEnter ? 'gone' : 'present');
  if (contentRef.current === null && children && state === 'gone') {
    setState('entering');
    wait(animationDuration).then(() => setState('present'));
  } else if (contentRef.current && !children && state === 'present') {
    setState('leaving');
    wait(animationDuration).then(() => {
      contentRef.current = null;
      setState('gone');
    });
  } else if (!contentRef.current && !children && state !== 'gone') {
    setState('gone');
  }
  if (children) contentRef.current = children;
  const content = children || contentRef.current;
  return (
    <div
      className={classnames('effect', `effect--${state}`, `effect--${effect}`)}
      style={{ transitionDuration: `${animationDuration}s` }}
    >
      {content}
    </div>
  );
}
